import { useLogout } from '@app/core/auth/authentication/components/useLogout';
import { useSplashBlocker } from '@app/core/splash/useSplashBlocker';
import { useEffect } from 'react';

export function LogoutPage() {
  const logout = useLogout();
  useSplashBlocker('logout', true);

  useEffect(() => {
    logout();
  }, []);

  return null;
}
